import React from "react";
import {
  Flex,
  Box,
  Icon,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { AiOutlineMenu } from "react-icons/ai";
import MenuList from "./MenuList";

const MenuMobile = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Box
        p="0.5rem"
        px="1rem"
        bg="menu.800"
        color="menu.100"
        position="fixed"
        w="100%"
        overflow="hidden"
        top="0"
        height="50px"
        zIndex="100"
      >
        <Flex justifyContent={"space-between"}>
          <Box>
            <img
              src="/images/logoJES.png"
              style={{ width: "3rem" }}
              alt="JES"
            ></img>
          </Box>
          <Icon
            w="2rem"
            h="2rem"
            as={AiOutlineMenu}
            onClick={() => onOpen()}
          ></Icon>
        </Flex>
      </Box>
      <Box mt="50px">{children}</Box>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="menu.800" color="menu.100">
          <DrawerCloseButton />

          <DrawerBody>
            <MenuList onClose={onClose}></MenuList>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default MenuMobile;
